import { Outlet } from "react-router-dom";
import Body from "./layout/Body";
import Snowfall from "react-snowfall";
import { useState, useEffect } from "react";

function App() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  // Update windowWidth when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.addEventListener("scroll", handleResize);
    };
  }, []);

  const mobileSnowDensity = 0.2;  // Lower density for mobile
  const desktopSnowDensity = 0.5;  // Higher density for larger screens

  // Calculate snowflake count and ensure it's a valid number
  let snowflakeCount = windowWidth < 768 ? mobileSnowDensity * 140 : desktopSnowDensity * 150;
  snowflakeCount = isNaN(snowflakeCount) ? 100 : snowflakeCount; // Ensure it's a valid number

  // Set speed to a valid number, which controls the falling speed of snowflakes
  const snowSpeed = [0.5, 1.0];

  return (
    <>
      <Body>
        {/* Avoid passing an object or iterable, pass individual numbers */}
        <div className="fixed top-0 left-0 w-full h-full z-0 pointer-events-none">
          {/* <Snowfall snowflakeCount={snowflakeCount} speed={snowSpeed} /> */}
        </div>
        <Outlet />
      </Body>
    </>
  );
}

export default App;
